export function Card({ children, className = '' }) {
  return (
    <div className={`rounded-xl border border-border bg-card shadow-card ${className}`}>{children}</div>
  );
}

export function CardHeader({ title, subtitle, action, className = '' }) {
  return (
    <div className={`flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 border-b border-border px-4 py-4 sm:px-5 ${className}`}>
      <div>
        {title && <h2 className="text-lg font-semibold text-text">{title}</h2>}
        {subtitle && <p className="mt-0.5 text-sm text-muted">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}

export function CardBody({ children, className = '' }) {
  return <div className={`px-4 py-4 sm:px-5 ${className}`}>{children}</div>;
}
